import type { SVGProps } from 'react';

export type IconName = 'arrow' | 'book' | 'briefcase' | 'chart' | 'check' | 'close' | 'home'
  | 'lightbulb' | 'logout' | 'menu' | 'mic' | 'practice' | 'search' | 'volume';

const paths: Record<IconName, React.ReactNode> = {
  arrow: <path d="m9 5 7 7-7 7" />,
  book: <path d="M5 4h11a3 3 0 0 1 3 3v13H7a2 2 0 0 1-2-2V4Zm0 13.5A2.5 2.5 0 0 1 7.5 15H19M9 8h6" />,
  briefcase: <path d="M4 7h16v13H4zM9 7V4h6v3m-11 5h16M10 12v2h4v-2" />,
  chart: <path d="M4 20V10m6 10V4m6 16v-7m4 7H2" />,
  check: <path d="m5 12 4 4L19 6" />,
  close: <path d="m6 6 12 12M18 6 6 18" />,
  home: <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6h-4v6H5a1 1 0 0 1-1-1v-9.5Z" />,
  lightbulb: <path d="M12 2a7 7 0 0 0-4 12.7V18h8v-3.3A7 7 0 0 0 12 2Zm-3 20h6M9 18h6" />,
  logout: <path d="M10 5H5v14h5m4-3 4-4-4-4m4 4H9" />,
  menu: <><circle cx="5" cy="12" r="1" /><circle cx="12" cy="12" r="1" /><circle cx="19" cy="12" r="1" /></>,
  mic: <path d="M12 3a4 4 0 0 0-4 4v5a4 4 0 0 0 8 0V7a4 4 0 0 0-4-4Zm-7 9a7 7 0 0 0 14 0M12 19v3m-4 0h8" />,
  practice: <path d="M12 3v18M5.6 5.6A9 9 0 0 1 12 3a9 9 0 0 1 6.4 2.6M5.6 18.4A9 9 0 0 0 12 21a9 9 0 0 0 6.4-2.6M3 12h18" />,
  search: <><circle cx="11" cy="11" r="7" /><path d="m16 16 5 5" /></>,
  volume: <path d="M5 9v6h4l5 4V5L9 9H5Zm12 1a3 3 0 0 1 0 4m2-7a7 7 0 0 1 0 10" />
};

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" aria-hidden="true" {...props}>{paths[name]}</svg>;
}
